import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class associatedObjectsService {
  // 获取可以关联的位号
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/ObjectAssociation/can-be-associated-tags?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取已关联的位号
  static async getAssociatedTags(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ObjectAssociation/associated-tags?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 保存位号与位号的关联关系
  static async saveTagAssoc(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ObjectAssociation/save-tag-assocation', payload)
    )
    return Callback(err, res)
  }
  // 批量删除位号关联关系
  static async deleteTagAssoc(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ObjectAssociation/tag-associations', { data: payload })
    )
    return Callback(err, res)
  }
  // 批量删除详情里的关联关系
  static async deleteObjAssoc(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ObjectAssociation/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 导出位号关联关系
  static async export(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ObjectAssociation/export-tag-associations', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 下载导入模板
  static async downloadTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/ObjectAssociation/download-export-tag-associations',
        payload,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 导入位号关联关系
  static async import(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ObjectAssociation/import-tag-associations', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
}
